import * as d3 from 'd3';
import Api from "../Api";
import Thinker from "../components/Thinker";

const TimeSeriesHistogram = function (options) {
    const container = $(options.container);

    function renderDurationChart() {
        Api.send(options.url, {guideid: container.data('id')}).done(function (values) {
            Thinker.end($(options.container));
            // Formatters for counts and times (converting numbers to Dates).
            const formatCount = d3.format(",.0f"),
                formatTime = d3.timeFormat("%H:%M:%S"),
                formatMinutes = function (d) {
                    return formatTime(new Date(2018, 0, 1, 0, 0, 0, d));
                },
                ticks = 25;

            const margin = {top: 10, right: 30, bottom: 30, left: 30},
                width = container.width() - margin.left - margin.right,
                height = 500 - margin.top - margin.bottom;

            const max = d3.max(values);
            const x = d3.scaleLinear()
                .domain([0, max + (max * 0.05)]) // add extra 5% space
                .range([0, width]);

            const bins = d3.bin()
                .domain(x.domain())
                .thresholds(x.ticks(ticks))
                (values);

            const y = d3.scaleLinear()
                .domain([0, d3.max(bins, function (d) {
                    return d.length;
                })])
                .range([height, 0]);

            const xAxis = d3.axisBottom()
                .scale(x)
                .tickFormat(formatMinutes);

            let svg = d3.select(options.svg)
                .attr("width", width + margin.left + margin.right)
                .attr("height", height + margin.top + margin.bottom);
            // add gradients & animation
            gradientDefs(svg, bins.length);
            // svg your g dawg
            svg = svg.append("g")
                .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

            const bar = svg.selectAll(".bar")
                .data(bins)
                .enter().append("g")
                .attr("class", "bar")
                .attr("transform", function (d) {
                    return "translate(" + x(d.x0) + "," + y(d.length) + ")";
                });

            bar.append("rect")
                .attr("x", 1)
                .attr('fill', function (d, i) {
                    return 'url(#grad' + i + ')';
                })
                .attr("width", x(bins[0].x1) - x(bins[0].x0) - 1)
                .attr("height", function (d) {
                    return height - y(d.length);
                });

            bar.append("text")
                .attr("dy", ".75em")
                .attr("y", 6)
                .attr("x", (x(bins[0].x1) - x(bins[0].x0)) / 2)
                .attr("text-anchor", "middle")
                .text(function (d) {
                    return formatCount(d.length);
                });

            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxis);
        });
    }

    /**
     * Create defs for linearGradients
     * @param svg
     * @param ticks
     */
    function gradientDefs(svg, ticks) {
        const start = {
            r: 98,
            g: 184,
            b: 238,
        };
        const end = {
            r: 238,
            g: 152,
            b: 98,
        };
        const defs = svg.append('defs');

        for (let i = 0; i < ticks; ++i) {
            const stop1 = {
                r: band(start.r, end.r, i / ticks),
                g: band(start.g, end.g, i / ticks),
                b: band(start.b, end.b, i / ticks)
            };
            const stop2 = {
                r: band(start.r, end.r, (i + 1) / ticks),
                g: band(start.g, end.g, (i + 1) / ticks),
                b: band(start.b, end.b, (i + 1) / ticks)
            };
            const start_rgb = 'rgb(' + start.r + ',' + start.g + ',' + start.b + ')',
                stop_color1 = 'rgb(' + stop1.r + ',' + stop1.g + ',' + stop1.b + ')',
                stop_color2 = 'rgb(' + stop2.r + ',' + stop2.g + ',' + stop2.b + ')';

            const grad = defs.append('linearGradient')
                .attr('id', 'grad' + i)
                .attr('x1', '0%')
                .attr('y1', '0%')
                .attr('x2', '100%')
                .attr('y2', '0%');
            grad.append('stop')
                .attr('offset', '0%')
                .attr('stop-opacity', 1)
                .attr('stop-color', start_rgb)
                .append('animate')
                .attr('attributeName', 'stop-color')
                .attr('from', start_rgb)
                .attr('to', stop_color1)
                .attr('dur', '2s')
                .attr('repeatCount', 1)
                .attr('fill', 'freeze');
            grad.append('stop')
                .attr('offset', '100%')
                .attr('stop-opacity', 1)
                .attr('stop-color', start_rgb)
                .append('animate')
                .attr('attributeName', 'stop-color')
                .attr('from', start_rgb)
                .attr('to', stop_color2)
                .attr('dur', '2s')
                .attr('repeatCount', 1)
                .attr('fill', 'freeze');
        }

        /**
         * Scale up or down between two values
         * @param _start
         * @param _end
         * @param percent
         * @returns {*}
         */
        function band(_start, _end, percent) {
            if (_start === _end) {
                return _start;
            }

            let diff;
            if (_start < _end) {
                diff = _end - _start;
                return diff * percent + _start;
            } else {
                diff = _start - _end;
                return _start - diff * percent;
            }
        }
    }

    setTimeout(update, 100);

    $('body').on('click', '.hamburger a', function () {
        update();
    });

    function update() {
        $(options.container).find('.guide-duration').empty();
        Thinker.begin($(options.container));
        setTimeout(renderDurationChart, 500);
    }
};

export default TimeSeriesHistogram;